module.exports = __webpack_public_path__ + "img/竖屏手机.27e8947d.png";